import * as React from "react"

import { LinkedIn, Twitter, YouTube, Facebook, Instagram } from "./Icon/"

const SocialMedia = () => (
	<ul className="flex flex-row justify-center lg:justify-start">
		<li>
			<a
				href="https://www.linkedin.com/company/hanseaticsoft-gmbh/"
				target="_blank"
				rel="noreferrer"
				title="Hanseaticsoft at LinkedIn"
				alt="Hanseaticsoft at LinkedIn"
				className="p-12 items-center text-jetblack hover:text-tealblue transition-color duration-300 ease-in-out">
				<LinkedIn />
			</a>
		</li>
		<li>
			<a
				href="https://twitter.com/hanseaticsoft"
				target="_blank"
				rel="noreferrer"
				title="Hanseaticsoft at Twitter"
				alt="Hanseaticsoft at Twitter"
				className="p-12 items-center text-jetblack hover:text-tealblue transition-color duration-300 ease-in-out">
				<Twitter />
			</a>
		</li>
		<li>
			<a
				href="https://www.youtube.com/c/Hanseaticsoft"
				target="_blank"
				rel="noreferrer"
				title="Hanseaticsoft at YouTube"
				alt="Hanseaticsoft at YouTube"
				className="p-12 items-center text-jetblack hover:text-tealblue transition-color duration-300 ease-in-out">
				<YouTube />
			</a>
		</li>
		<li>
			<a
				href="https://www.facebook.com/Hanseaticsoft"
				target="_blank"
				rel="noreferrer"
				title="Hanseaticsoft at Facebook"
				alt="Hanseaticsoft at Facebook"
				className="p-12 items-center text-jetblack hover:text-tealblue transition-color duration-300 ease-in-out">
				<Facebook />
			</a>
		</li>
		<li>
			<a
				href="https://www.instagram.com/hanseaticsoft/"
				target="_blank"
				rel="noreferrer"
				title="Hanseaticsoft at Instagram"
				alt="Hanseaticsoft at Instagram"
				className="p-12 items-center text-jetblack hover:text-tealblue transition-color duration-300 ease-in-out">
				<Instagram />
			</a>
		</li>
	</ul>
)

export default SocialMedia
